import type { FaireProductEntity } from "../../entity_types/product";

export const p_nj95wd456k: FaireProductEntity = {
  token: "p_nj95wd456k",
  type: "product",
  name: "Allergy Relief for Kids",
  brandToken: "b_63rejl12p8",
  brandName: "Forces of Nature",
  imageUrl:
    "https://cdn.faire.com/fastly/5ab52f9403b24cad0d200be5a9832a9b060d5a4823fea0bd3a3003275fe2378b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bb50e54edc7ac7d1cf57fc4a3e9b47a2062062cd914902590a241acdc309f32.png",
    "https://cdn.faire.com/fastly/b57ce0c36bc0174565751de7eab32fecfe159112760c21df972c04c8b332700e.png",
    "https://cdn.faire.com/fastly/3f83353cc55982458055412f03f387acf418d555472a432813a06bf8504df8e0.jpeg",
    "https://cdn.faire.com/fastly/ce3ae3f48b2687e153abbca968c9dd52d7e7980f1cc3d6674e69f2bad3a26fa8.png",
    "https://cdn.faire.com/fastly/2d14bf657324b2d16ec3c9d6f4f7f3da88f0850dcfb612ee4f71cde65cb0329e.png",
    "https://cdn.faire.com/fastly/e57ee01c2c4f263f653d05ecdd65a8b957509364c80db445c432dc758a15ee96.png",
    "https://cdn.faire.com/fastly/9900d4f89121b4593f1a439de309fee58a577a8eb03c63d20252a4883b0a82da.png",
  ],
  priceDollars: 10.38,
  description:
    "Forces of Nature Allergy Kids is a gentle, yet effective solution to relieve bothersome allergy symptoms like sneezing, runny nose, itchy eyes, and congestion. Allergy Kids is formulated with a unique blend of organic homeopathic medicines at lower potencies designed for young bodies. Active ingredients include Urtica Dioica (Stinging Nettle) and Althaea Officinalis (Marsh-mallow) that work to calm inflammation and are known to calm allergic reactions, reducing histamine-like responses.\n\nWhile conventional OTC allergy medicines often contain synthetic ingredients, sugars, or alcohol that can cause drowsiness, cottonmouth, or other unwanted side effects, this clean plant-based formula works in harmony with your child’s body to ease discomfort. Bergamot orange oil and glycerin (USP) provide a natural sweetness that make taking the medicine easy.\n\nParents can feel confident choosing Allergy Kids because it’s Certified Organic, Non-GMO Project Verified, cruelty free, and free from harsh chemicals, dyes, sugar, or artificial additives. Give your child the natural support they need to breathe easier and feel better.\n\nSee also our Allergy Relief product for adults.\n",
  tags: [],
  msrpDollars: 20.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:15.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
